<template>
  <div class="payment-history-vue">
    <Header>
      <template v-slot:title>
        {{ $t("payment-history-6ecdeeece7dc4ee366197ea2e4b6b778") }}
      </template>
    </Header>
    <div
      v-if="get_ib_profile.state === 'Approved'"
      class="bg-white shadow rounded-md min-h-screen m-auto max-w-7xl p-0 pb-16 sm:mt-5"
    >
      <div>
        <div class="flex flex-col">
          <div class="overflow-x-auto">
            <div class="align-middle inline-block min-w-full">
              <div class="overflow-hidden border-b border-gray-200">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead>
                    <tr>
                      <th
                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {{ $t("request-id") }}
                      </th>
                      <th
                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {{ $t("Type") }}
                      </th>
                      <th
                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {{ $t("Amount") }}
                      </th>
                      <th
                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {{ $t("Date") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="get_ib_payment_history"
                    class="bg-white divide-y divide-gray-200"
                  >
                    <tr
                      v-for="(payment, index) in get_ib_payment_history.results"
                      :key="index"
                    >
                      <td
                        class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                      >
                        {{ payment.id }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                      >
                        {{ payment.type }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                      >
                        {{ payment.value }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                      >
                        {{ payment.date | moment("MM-DD-YYYY, h:mm:ss A") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-if="get_ib_payment_history && get_ib_payment_history.count"
        :clientPagination="false"
        :pagination="pagination"
        :results="get_ib_payment_history.count"
        class="border-t-none border-b"
        @new="newPage"
        @next="nextPage"
        @previous="previousPage"
      ></pagination>
    </div>
    <ib-approval-alert v-if="get_ib_profile.state === 'Pending'" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MoneyFormat from "vue-money-format";
import Header from "@/components/Header";
import Pagination from "@/components/Pagination";
import IbApprovalAlert from "@/components/IbApprovalAlert";

export default {
  name: "PaymentHistory",
  components: {
    "money-format": MoneyFormat,
    Header,
    Pagination,
    IbApprovalAlert,
  },
  data() {
    return {
      pagination: {
        limit: 10,
        offset: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["get_ib_payment_history", "get_ib_profile"]),
  },
  created() {
    this.$store.dispatch("set_ib_payment_history", this.pagination);
  },
  methods: {
    newPage(data) {
      this.pagination = data;
      this.$store.dispatch("set_ib_payment_history", this.pagination);
    },
    previousPage() {
      if (this.get_ib_payment_history.previous !== null)
        this.$store.dispatch(
          "set_ib_payment_history_previous",
          this.get_ib_payment_history.previous
        );
    },
    nextPage() {
      if (this.get_ib_payment_history.next !== null)
        this.$store.dispatch(
          "set_ib_payment_history_previous",
          this.get_ib_payment_history.next
        );
    },
  },
};
</script>